import { memo } from 'react';

import { Form } from '@components/form';

import { useTranslatedFieldText } from './locale';
import { FormField } from './types';

export const TextInput = memo<{ field: FormField }>(({ field }) => {
  return (
    <Form.TextField
      {...field}
      label={useTranslatedFieldText(field.text)}
      defaultValue={field.value}
    />
  );
});
